import {
  LOCAL_NAVIGATION_PENDING,
  LOCAL_NAVIGATION_SUCCESS,
  LOCAL_NAVIGATION_ERROR,

  LOCAL_SELECTION_CHANGED
} from "../actions/file-catalyst-actions";
import {get_previous_path} from "../utils"

const initialState = {
  files              : [],
  files_loading      : false,
  previous_path      : null,
  current_path       : '/',
  create_folder      : false,
  files_error        : null
}

export default function fileCatalyst(state = initialState, action = {}) {

  switch (action.type) {
    case LOCAL_NAVIGATION_PENDING:
      return {...initialState, files_loading:true, create_folder : false}

    case LOCAL_NAVIGATION_SUCCESS:
      return {...state,
        current_path  : (action||{}).data.directory,
        previous_path : get_previous_path(((action||{}).data||{}).directory),
        files         : (action||{}).data.fileObjectList.filter((e) => !e.isHidden && e.name !== '..'),
        files_loading : false,
        files_error   : null
      }

    case LOCAL_NAVIGATION_ERROR:
      return {
        ...state,
        files_loading : false,
        files_error   : action.message
      }

    case LOCAL_SELECTION_CHANGED:
      return {
        ...state,
        selection : action.selection
      }

    default:
      return state;
  }
}
